import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coins, Heart, Quote } from "lucide-react";
import { api } from "@/lib/api";

const sinceDe = (d) => d ? `Mitglied seit ${new Date(d).toLocaleDateString("de-DE", { month: "long", year: "numeric" })}` : "Mitglied";

export function MemberVoices() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/public/voices").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (!list?.length) return null;
  return (
    <div className="w-full max-w-md space-y-2.5" data-testid="member-voices">
      <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-rose-500 px-1">Das sagen unsere Mitglieder</p>
      {list.map((v, i) => (
        <figure key={i} className="relative shine glow-pulse rounded-2xl bg-white/90 border border-rose-100 p-4" style={{ "--shine-delay": `${3 + i * 0.7}s`, animationDelay: `${i * 0.6}s` }} data-testid={`member-voice-${i}`}>
          <Quote className="absolute top-3 right-3 w-5 h-5 text-rose-100" />
          <blockquote className="text-sm text-slate-700 leading-relaxed pr-6">„{v.text}“</blockquote>
          <figcaption className="mt-3 flex items-center gap-2.5">
            {v.picture ? <img src={v.picture} alt={v.name} className="w-9 h-9 rounded-full object-cover ring-2 ring-rose-100" />
              : <span className="w-9 h-9 rounded-full bg-gradient-to-br from-rose-400 to-fuchsia-500 text-white text-sm font-extrabold flex items-center justify-center">{v.name?.[0]?.toUpperCase()}</span>}
            <span className="flex-1 min-w-0"><span className="block text-sm font-bold text-slate-900">{v.name}</span><span className="block text-[11px] text-slate-400">{sinceDe(v.since)}</span></span>
            {v.likes > 0 && <span className="flex items-center gap-1 text-xs font-bold text-rose-500"><Heart className="w-3.5 h-3.5 fill-rose-500" /> {v.likes}</span>}
          </figcaption>
        </figure>
      ))}
    </div>
  );
}

export function TopRewards() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/public/top-rewards").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (!list?.length) return null;
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-14" data-testid="top-rewards">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
        <div>
          <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-rose-500">Das kannst du dir holen</p>
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 mt-1">Die beliebtesten Prämien</h2>
        </div>
        <Link to="/registrieren" data-testid="top-rewards-cta" className="text-sm font-bold text-rose-600 hover:underline">Jetzt Punkte sammeln →</Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
        {list.map((r, i) => (
          <Link to="/registrieren" key={r.id} data-testid={`top-reward-${r.id}`} className="group shine glow-pulse rounded-3xl bg-white border border-rose-100 overflow-hidden hover:-translate-y-1 transition-transform duration-300" style={{ "--shine-delay": `${i * 0.5}s`, animationDelay: `${i * 0.4}s` }}>
            <div className="aspect-[4/3] overflow-hidden bg-rose-50">{r.image && <img src={r.image} alt={r.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}</div>
            <div className="p-3 sm:p-4">
              <p className="font-bold text-sm sm:text-base text-slate-900 line-clamp-1">{r.title}</p>
              <p className="mt-1.5 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 text-xs font-extrabold"><Coins className="w-3.5 h-3.5" /> {r.cost.toLocaleString("de-DE")} Punkte</p>
              {r.redeemed > 0 && <p className="mt-1.5 text-[11px] text-slate-400">{r.redeemed}× eingelöst</p>}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
